import {
    makeErrorFingerprint,
    ReportErrorOptions,
    shouldSkipReporting,
} from "util/error-tracking";

export type TrpcErrorReport = (error: Error, options: ReportErrorOptions) => void;

export const isTrpcErrorReportable = (error: unknown): boolean =>
    !shouldSkipReporting(error);

export const trpcPathFromKey = (key: unknown): string => {
    const segments = Array.isArray(key) ? key[0] : undefined;
    return Array.isArray(segments) ? segments.join(".") : "unknown";
};

export const makeTrpcErrorReporter =
    (report: TrpcErrorReport) =>
    (error: unknown, trpcPath: string): void => {
        if (!isTrpcErrorReportable(error)) {
            return;
        }
        const reportable = error as Error;
        report(reportable, {
            fingerprint: makeErrorFingerprint("trpc", trpcPath, error),
            params: { message: reportable?.message },
            context: { trpcPath },
        });
    };
